/**
 * Haptic feedback utility
 * Uses navigator.vibrate if available
 */

export const triggerHaptic = (pattern = [10]) => {
    // Check if haptic feedback is enabled in user preferences
    const hapticEnabled = localStorage.getItem('hapticEnabled');

    // Default to true if not set (enabled by default)
    if (hapticEnabled === 'false') {
        return; // Exit early if haptic feedback is disabled
    }

    if (typeof navigator !== 'undefined' && navigator.vibrate) {
        try {
            navigator.vibrate(pattern);
        } catch (e) {
            // Ignore errors if vibration is not supported or allowed
            console.debug('Haptic feedback failed', e);
        }
    }
};

export const HapticPatterns = {
    light: [10],
    medium: [40],
    heavy: [60],
    success: [10, 30, 10],
    error: [50, 30, 50, 30, 50],
    warning: [30, 30, 30]
};
